import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react"; // icons for mobile menu
import logo from "../assets/images/logo.jpg";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md fixed w-full top-0 left-0 z-50">
      <div className="w-4/5 mx-auto flex justify-between items-center py-4">
        {/* LEFT: Logo + Name */}
        <div className="flex items-center gap-3">
          <img src={logo} alt="Logo" className="w-10 h-10 object-contain" />
          <span className="font-bold text-2xl text-gray-900">
            Dotti<span className="text-[#007AFF]"> Verify</span>
          </span>
        </div>

        {/* MIDDLE: Nav Links (hidden on mobile) */}
        <nav className="hidden md:flex gap-8 text-gray-700 font-medium">
          <Link to="/" className="hover:text-[#007AFF] transition">
            Home
          </Link>
          <Link to="/about" className="hover:text-[#007AFF] transition">
            About
          </Link>
          <Link to="/services" className="hover:text-[#007AFF] transition">
            Services
          </Link>
          <Link to="/contact" className="hover:text-[#007AFF] transition">
            Contact Us
          </Link>
        </nav>

        {/* RIGHT: Buttons (hidden on mobile) */}
        <div className="hidden md:flex gap-4">
          <Link
            to="/Login"
            className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition inline-block"
          >
            Sign In
          </Link>

          <Link
            to="/SignUp"
            className="px-5 py-2 rounded-lg bg-[#007AFF] text-white hover:bg-blue-600 transition inline-block"
          >
            Sign Up
          </Link>
        </div>

        {/* MOBILE MENU BUTTON */}
        <button
          className="md:hidden text-gray-700"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* MOBILE MENU DROPDOWN */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="flex flex-col items-center gap-6 py-6 text-gray-700 font-medium">
            <Link to="/" onClick={() => setMenuOpen(false)}>
              Home
            </Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>
              About
            </Link>
            <Link to="/services" onClick={() => setMenuOpen(false)}>
              Services
            </Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              Contact Us
            </Link>

            {/* Buttons in mobile menu */}
            <div className="flex flex-col gap-4 w-4/5">
              <Link
                to="/Login"
                className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
              >
                Sign In
              </Link>
              <Link
                to="/Login"
                className="px-5 py-2 rounded-lg bg-[#007AFF] text-white hover:bg-blue-600 transition"
              >
                Sign Up
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;
